<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/N7jV8B/tc-custom/9781429965255.jpg?1718151409651" alt="This image is the cover for the book Second Skin, The Nocturne City Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Second Skin, The Nocturne City Novels
      </h1>
      <p class="bookDescription body article font2">
        <p>When werewolves from Nocturne City's oldest packs start showing up shot through the head execution-style, police officer Luna Wilder must find out what's killing them and why…before she becomes the next victim.<br/><br/>Luna traces the killings to a band of shapeshifters made of smoke and shadow who drink the blood of their victims for strength. Believed to exist only in legend, their race is all too real—and now their leader, Lucas Kennuka, is out to wrest Luna's heart from her beloved Dmitri. To make matters worse, Dmitri is suffering from a mysterious illness brought on by a demon bite, and his condition grows more grave with each passing day. Now Luna must rely on Lucas to defeat an invisible enemy—a serial were-killer bringing death and destruction to all who stand in its path…</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Caitlin Kittredge
      </h2>
      
      <p class="authorDescription body article"><P><B>Caitlin Kittredge</B> is the author of the Nocturne City and Black London series, as well as several short stories. She started writing novels at age 13, and after a few years writing screenplays, comic books and fan-fiction, she wrote <I>Night Life</I>, her debut novel. She is the proud owner of an English degree, two cats, a morbid imagination, a taste for black clothing, punk rock, and comic books. She's lucky enough to write full time and watches far too many trashy horror movies. She lives in Olympia, Washington.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5f354c3c